import styled from "styled-components";

const StyledForm = styled.form`
  flex-direction: column;
`;

export default StyledForm;
